import { Pipe, PipeTransform, inject } from '@angular/core';
import { ReportFormStore } from '../../reports/services';
import { toSignal } from '@angular/core/rxjs-interop';

@Pipe({
  name: 'formatText',
  standalone: true
})
export class FormatTextPipe implements PipeTransform {
  reportStore = inject(ReportFormStore);
  general = toSignal(this.reportStore.general$);
  reportId = this.general()?.uniqueId || '';

  transform(value: string | null | undefined): string {
    if (!value) return '';

    let text = value;

    text = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n');

    text = text.replace(/[ \t]+/g, ' ');

    // Split by double newlines to create paragraphs
    const paragraphs = text
      .split(/\n\s*\n+/)
      .map(p => p.trim())
      .filter(p => p.length > 0);

    // Process each paragraph
    const htmlParagraphs = paragraphs.map(paragraph => {
      const lines = paragraph
        .split('\n')
        .map(line => line.trim())
        .filter(line => line.length > 0);

      const content = lines.join('<br>');
      return `<p>${this.formatSentences(content)}</p>`;
    });

    return htmlParagraphs.join('');
  }

  private formatSentences(text: string): string {

    // Convert any https:// URL in the text to a clickable link
    text = text.replace(
      /(https?:\/\/[^\s<]+)/gi,
      `<a href="$1" target="_blank" rel="noopener noreferrer">${this.reportId}</a>`
    );
    // If the string starts with https://, make the whole string a clickable link and return immediately
    if (/^https?:\/\//i.test(text.trim())) {
      const url = text.trim();
      return `<a href="${url}" target="_blank" rel="noopener noreferrer">${this.reportId}</a>`;
    }

    text = text.charAt(0).toUpperCase() + text.slice(1);

    // Add line breaks before specific keywords (English, Russian, Kazakh)
    const keywords = [
      'Description',
      'Resolution Target Date',
      'Link',
      'Описание',
      'Срок выполнения',
      'Cсылка',
      'Ссылка',
      'Сипаттама',
      'Шешім шығарылу күні',
      'Сілтеме',
    ];

    keywords.forEach(keyword => {
      // Add line break before keyword (but not if it's at the very start or already after <br>)
      const regex = new RegExp(`(?<!^|<br>)\\s+(${keyword})(:?)`, 'gi');
      text = text.replace(regex, '<br>$1$2');
    });

    keywords.forEach(keyword => {
      const regex = new RegExp(`(^|<br>)(${keyword})(:?)`, 'gi');
      text = text.replace(regex, '$1<strong>$2</strong>$3');
    });

    // Comment labels need the colon so a plain word "comment" inside a sentence is left alone
    const commentKeywords = ['Comment', 'Комментарий', 'Түсініктеме'];

    commentKeywords.forEach(keyword => {
      text = text.replace(new RegExp(`(?<!^|<br>)\\s+(${keyword})(:)`, 'gi'), '<br>$1$2');
      text = text.replace(new RegExp(`(^|<br>)(${keyword})(:)`, 'gi'), '$1<strong>$2</strong>$3');
    });

    text = text.replace(
      /((?:<strong>)?(?:<\/strong>)?:\s*)(https?:\/\/[^\s<]+)/gi,
      '$1<a href="$2" target="_blank" rel="noopener noreferrer">$2</a>'
    );

    // Capitalize after sentence-ending punctuation (. ! ?)
    text = text.replace(/([.!?]\s+)([a-zа-яёәіңғүұқөһ])/gi, (match, punct, letter) => {
      return punct + letter.toUpperCase();
    });

    return text;
  }
}
